import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

// Grommet
import { ResponsiveContext } from 'grommet'

import Moment from 'react-moment'

// Spinner
import PulseLoader from 'react-spinners/PulseLoader'

// Services
import LocalStorageService from '../../services/LocalStorageService'
import NotificationService from '../../services/NotificationService'
import UserService from '../../services/UserService'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import DataTable from '../../components/simple/dataTable/DataTable.js'
import Text from '../../components/simple/text/Text'

import NotificationLayer from '../../components/compound/notification/NotificationLayer'

// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import PasswordService from '../../services/PasswordService.js'

function UserList (props) {
  const [userValues, setUserValues] = useState([])
  const [showDeleteOptions, showDelete] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const activeOrg = LocalStorageService.get('activeOrg')

  const [sort, setSort] = useState({
    property: 'name',
    direction: 'asc'
  })

  // Prompt user to delete
  const showDeleteUserOptions = (user) => {
    setUserToDelete(user)
    showDelete(true)
  }

  // Delete a User
  const deleteUser = async () => {
    const apiToken = LocalStorageService.get('apiToken')
    // Delete from server
    const response = await UserService.deleteUser(apiToken, userToDelete)
    if (response.data.success === 'true') {
      // And from state to force a refresh
      const newUserValues = userValues.filter((item) => item.id !== userToDelete.id)
      setUserValues(newUserValues)
      NotificationService.info('User deleted')
    } else {
      NotificationService.error(response.error)
    }
    showDelete(false)
  }

  // Reset User password
  const resetPassword = async (email) => {
    try {
      var passwordResetStatus = await PasswordService.resetPasswordRequest(null, email)
    } catch (err) {
      NotificationService.error('Password reset error - ', err)
      return
    }

    NotificationService.success('Password reset email has been sent')
  }

  // Basically componentDidMount
  // useEffect(() => {
  //   let unmounted = false

  //   // Get Users for this organisation
  //   const getUsers = async () => {
  //     const apiToken = LocalStorageService.get('apiToken')

  //     var params = {
  //       fields: 'id,firstName,lastName,email,userName,reference,ethnicity,gender,createdAt',
  //       limit: 1000,
  //       orgId: activeOrg.id
  //     }

  //     params.where = {
  //       organisation: props.activeOrg.id,
  //       type: 'user'
  //     }

  //     setLoading(true)
  //     const users = await UserService.getUsers(apiToken, params)
  //     if (users?.error) {
  //       NotificationService.error(users.error)
  //     } else {
  //       if (!unmounted) {
  //         if (users?.data) {
  //           const mappedUsers = users.data.map((data, index) => ({
  //             id: data.id,
  //             name: data.firstName + ' ' + data.lastName,
  //             email: data.email,
  //             created: <Moment format='MMM Do YYYY-HH:mm'>{data.createdAt}</Moment>
  //           }))
  //           setUserValues(mappedUsers)
  //         }
  //       }
  //     }
  //   }

  //   getUsers()
  //   setLoading(false)

  //   return () => { unmounted = true }
  // }, [])

  // Refresh if active Org changes
  useEffect(() => {
    // TODO: DRY - How do we do this ?
    // Get Users for this organisation
    const getUsers = async () => {
      const apiToken = LocalStorageService.get('apiToken')

      var params = {
        fields: 'id,firstName,lastName,email,userName,reference,ethnicity,gender,createdAt',
        limit: 2000,
        orgId: activeOrg.id,
        type: 'user'
      }

      params.where = {
        // organisation: props.activeOrg.id,
        // type: 'user'
      }

      setLoading(true)
      const users = await UserService.getUsers(apiToken, params)
      if (users?.error) {
        // NotificationService.error(users.error)
      } else {
        if (users?.data) {
          const mappedUsers = users.data.map((data, index) => ({
            id: data.id,
            name: (data.firstName || '') + ' ' + (data.lastName || ''),
            email: data.email,
            created: <Moment format='DD/MM/YYYY'>{data.createdAt}</Moment>
          }))
          setUserValues(mappedUsers)
        }
      }
    }

    getUsers()
    setLoading(false)
  }, [props.activeOrg])

  const userColumns = [
    {
      property: 'name',
      header: <Text weight={500}>Name</Text>,
      render: datum => (
        <Anchor href={`/user/${datum.id}/profile`} color='primary'>
          <Text>{datum.name}</Text>
        </Anchor>
      ),
    },
    {
      property: 'email',
      header: <Text weight={500}>Email</Text>,
      render: datum => (
        <Anchor href={`/user/${datum.id}/profile`} color='primary'>
          <Text>{datum.email}</Text>
        </Anchor>
      ),
    },
    {
      property: 'created',
      header: <Text weight={500}>Created</Text>
    },
    {
      property: 'actions',
      header: <Text weight={500}>Actions</Text>,
      render: datum => (
        <Box direction='row'>
          <ActionButton
            onClick={() => resetPassword(datum.email)}
            target='_self'
            plain
            children={
              <Box pad='5px'>
                <FontAwesomeIcon icon={['fal', 'key']} color='#ff8300' />
                {/* <License color='primary' size='medium' /> */}
              </Box>
            }
          />

           <ActionButton
            href={`/user/${datum.id}/profile`}
            target='_self'
            plain
            children={
              <Box pad='5px'>
                <FontAwesomeIcon icon={['fal', 'eye']} color='#ff8300' />
                {/* <FormEdit color='primary' size='medium' /> */}
              </Box>
            }
          />

          <ActionButton
            target='_self'
            plain
            onClick={() => showDeleteUserOptions(datum)}
            children={
              <Box pad='5px'>
                <FontAwesomeIcon icon={['fal', 'trash']} color='#ff8300' />
                {/* <FormTrash color='primary' size='medium' /> */}
              </Box>
            }
          />
        </Box>
      )
    }
  ]

  return (
    <>
      {showDeleteOptions &&
        <NotificationLayer button1Text='Yes' button1Click={deleteUser} button2Text='No' button2Click={() => { showDelete(false) }}>Are you sure you want to delete user {userToDelete.name}?</NotificationLayer>}

      <BreadcrumbBar
        title='System Users Page'
        path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='besmartBlue' size='xsmall'>{window.location.pathname}</Text></>}
      />

      <Box background='white' direction='column' gap='small' round='small'>

        <Box direction='row-responsive' gap='xlarge' justify='between' pad={{ horizontal: 'medium', top: 'medium' }}>
          <Box>
            <Text color='#000' size='large' weight='bold'>System Users Page</Text>
          </Box>
          <Box direction='row' gap='xsmall'>
            <ActionButton href='user/new/upload' label={<Text><FontAwesomeIcon icon={['fal', 'cloud-upload']} /> Bulk Upload</Text>} secondary />
            <ActionButton href='user/new/edit' label={<Text><FontAwesomeIcon icon={['fal', 'plus-circle']} /> Add User</Text>} target='_self' />
          </Box>
        </Box>

        <Box direction='column' gap='medium' pad={{ horizontal: 'medium', bottom: 'small' }}>
          <Box align='center'>
            <PulseLoader
              size={15}
              color='orange'
              loading={loading}
            />
          </Box>

          <ResponsiveContext.Consumer>
            {responsive => (
              <DataTable
                columns={['xsmall', 'small'].includes(responsive) ? userColumns.filter(el => (el.property !== 'email' && el.property !== 'created')) : userColumns}
                data={userValues}
                primaryKey='id'
                sort={sort}
                onSort={setSort}
                step={2000}
              />)}
          </ResponsiveContext.Consumer>
        </Box>
      </Box>
    </>
  )
}

export default UserList
